import { render, staticRenderFns } from "./WeChatNewsInfo.vue?vue&type=template&id=571f9ddf&scoped=true&"
import script from "./WeChatNewsInfo.vue?vue&type=script&lang=js&"
export * from "./WeChatNewsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f9ddf",
  null
  
)

export default component.exports